/** Protocol 12 control coordinates: yaw zero is +Z; positive pitch aims upward. */
export const PLAYER_COMMAND_SECONDS = 0.05;
export const PLAYER_COMMAND_HZ = 20;
export const PLAYER_AIM_PITCH_MIN = -65 * Math.PI / 180;
export const PLAYER_AIM_PITCH_MAX = 70 * Math.PI / 180;
export const PLAYER_SAVED_COMMAND_LIMIT = 128;
export var PlayerStance;
(function (PlayerStance) {
    PlayerStance[PlayerStance["Standing"] = 0] = "Standing";
    PlayerStance[PlayerStance["Crouched"] = 1] = "Crouched";
})(PlayerStance || (PlayerStance = {}));
export var PlayerGait;
(function (PlayerGait) {
    PlayerGait[PlayerGait["Walk"] = 0] = "Walk";
    PlayerGait[PlayerGait["Run"] = 1] = "Run";
    PlayerGait[PlayerGait["Sprint"] = 2] = "Sprint";
})(PlayerGait || (PlayerGait = {}));
export var PlayerMotionMode;
(function (PlayerMotionMode) {
    PlayerMotionMode[PlayerMotionMode["Active"] = 0] = "Active";
    PlayerMotionMode[PlayerMotionMode["Ragdoll"] = 1] = "Ragdoll";
    PlayerMotionMode[PlayerMotionMode["GettingUp"] = 2] = "GettingUp";
})(PlayerMotionMode || (PlayerMotionMode = {}));
export var PlayerAction;
(function (PlayerAction) {
    PlayerAction[PlayerAction["MainPress"] = 1] = "MainPress";
    PlayerAction[PlayerAction["MainRelease"] = 2] = "MainRelease";
    PlayerAction[PlayerAction["SecondaryPress"] = 4] = "SecondaryPress";
    PlayerAction[PlayerAction["SecondaryRelease"] = 8] = "SecondaryRelease";
})(PlayerAction || (PlayerAction = {}));
export const PLAYER_SPEED = Object.freeze({ walk: 4.2, run: 6.2, sprint: 8.0, crouch: 2.3 });
export const RAGDOLL_CONFIG = Object.freeze({ minimumSpeed: 6, minimumNormalSpeed: 5.2,
    minimumHeadOn: 0.78, minimumSeconds: 1.5, maximumSeconds: 4, settledSpeed: 0.25,
    getUpSeconds: 1.65, cooldownSeconds: 1.0, rootDamping: 4.5 });
export function normalizePlayerYaw(yaw) {
    return Number.isFinite(yaw) ? Math.atan2(Math.sin(yaw), Math.cos(yaw)) : 0;
}
export function playerYawDifference(from, to) { return normalizePlayerYaw(to - from); }
export function clampPlayerPitch(pitch) {
    return Number.isFinite(pitch) ? Math.max(PLAYER_AIM_PITCH_MIN, Math.min(PLAYER_AIM_PITCH_MAX, pitch)) : 0;
}
/** Moving hips follow aim; standing hips allow a comfortable 50-degree torso offset. */
export function advancePlayerBodyYaw(bodyYaw, aimYaw, moving, dt) {
    const offset = playerYawDifference(bodyYaw, aimYaw);
    const comfort = 50 * Math.PI / 180;
    const desired = moving ? offset : Math.sign(offset) * Math.max(0, Math.abs(offset) - comfort);
    return normalizePlayerYaw(bodyYaw + desired * (1 - Math.exp(-(moving ? 16 : 10) * Math.max(0, Math.min(0.25, dt)))));
}
